import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";
import { useSearchParams } from "react-router-dom";

function ContactUsPage() {
  const email = "support@collabish.com";
  const [searchParams] = useSearchParams();
  const isBrandInquiry = searchParams.get("from") === "brand";

  return (
    <Center style={{ height: "calc(100vh - 200px)" }}>
      <Stack align="center">
        <Title order={1}>
          {isBrandInquiry ? "Onboard Your Brand" : "Contact Us"}
        </Title>
        <Text size="lg">
          {isBrandInquiry
            ? "Get in contact with us to onboard your brand!"
            : "Have questions? We're here to help."}
        </Text>
        <Text c="dimmed" size="md">
          Our email is: {email}
        </Text>
        <Button
          component="a"
          href={`mailto:${email}`}
          leftSection={<IconMail size={14} />}
          size="lg"
          variant="filled"
        >
          Email Us
        </Button>
      </Stack>
    </Center>
  );
}

export default ContactUsPage;